import { ApiError } from "../data/api/errors";

/**
 * The message to show when a write fails.
 *
 * Actions write their failures out in full — a 409 when something was decided
 * under you, a 404 when the record closed, a 502 naming what the vendor
 * rejected — so the server's own `detail` is preferred over anything generic.
 * Swallowing it leaves a panel silently reverting as though nothing happened,
 * which is the one outcome a person cannot act on.
 *
 * `fallback` is for the case with no message at all (a network drop), and
 * should say what failed in the caller's own terms rather than "Error".
 */
export function mutationErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError && err.detail) return err.detail;
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
